import React, { useRef, useLayoutEffect, useState } from 'react';
import styled from 'styled-components';

export interface ContextMenuProps {
  top: number;
  left: number;
  children?: React.ReactNode;
}

export const ContextMenuContainer: React.FC<ContextMenuProps> = ({
  top,
  left,
  children,
}) => {
  const menuRef = useRef<HTMLDivElement>(null);
  const [adjustedPosition, setAdjustedPosition] = useState<{
    top?: number;
    left?: number;
  }>({ top, left });

  useLayoutEffect(() => {
    const menu = menuRef.current;
    if (!menu) return;

    const parent = menu.offsetParent as HTMLElement | null;
    if (!parent) return;

    const menuRect = menu.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();

    const menuHeight = menuRect.height;
    const menuWidth = menuRect.width;
    const parentHeight = parentRect.height;
    const parentWidth = parentRect.width;

    const OFFSET = 16;

    let newTop = top - menuHeight / 2;

    let newLeft = left + OFFSET;
    if (newLeft + menuWidth > parentWidth) {
      newLeft = left - menuWidth - OFFSET;
    }

    newTop = Math.max(0, Math.min(newTop, parentHeight - menuHeight));
    newLeft = Math.max(0, Math.min(newLeft, parentWidth - menuWidth));

    setAdjustedPosition({ top: newTop, left: newLeft });
  }, [top, left, children]);

  return (
    <StyledContextMenu
      ref={menuRef}
      $top={adjustedPosition.top}
      $left={adjustedPosition.left}
    >
      {children}
    </StyledContextMenu>
  );
};

const StyledContextMenu = styled.div<{
  $top?: number;
  $left?: number;
}>`
  position: absolute;
  z-index: 10;
  background: white;
  box-shadow: 0px 2px 8px 0px #00000026;
  border-radius: 7px;
  padding: 10px;

  ${({ $top }) => $top !== undefined && `top: ${$top}px;`}
  ${({ $left }) => $left !== undefined && `left: ${$left}px;`}
`;
